export function handleMenuItemClick(item, history) {
  if (item.action) {
    return item.action();
  } else if (item.route) {
    history(`${item.route}`);
  } else {
    window.open(`${item.link}`, "_blank");
  }
}
